import * as React from 'react';
import SearchView from 'containers/search';
import { PwrDistroQuestionFieldsets } from 'containers/search/SearchForm';

export function QuestionSearch(props) {
  return (
    <SearchView
      label="Questions"
      primaryFieldsets={PwrDistroQuestionFieldsets.primaryFieldsets}
      extraFieldsets={PwrDistroQuestionFieldsets.extraFieldsets}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/PwrDistribution/QuestionSearch.js